import { Controller } from "@hotwired/stimulus";
import { attachSummernote } from '../../../../../../scripts/summernoteHelper';
import { configureTypeaheadAutocomplete } from "../../../../../../scripts/typeaheadHelper";
import { ContentQuality } from "../../../../../../scripts/_generated/ContentQuality";
import { DomEvents } from "../../../../../../scripts/_generated/DomEvents";
import { PointOfInterestConstants } from "../../../../../../scripts/_generated/PointOfInterestConstants";

export default class BasicInformationController extends Controller {
    static targets = [
        "description",
        "extraInfo",
        "author",
        "authorUserId",
        "contentQuality"
    ];

    static values = {
        searchUsersUrl: String
    };

    readonly descriptionTarget!: HTMLElement;
    readonly extraInfoTarget!: HTMLElement;
    readonly authorTargets!: HTMLElement[]; // collection needed - typeahead creates another input
    readonly authorUserIdTarget!: HTMLElement;
    readonly contentQualityTarget!: HTMLSelectElement;

    readonly searchUsersUrlValue!: string;

    connect() {
        this.setupSummerNoteHtmlEditor();
        this.configureAuthorSearch();

        this.dispatch(DomEvents.poiDetailBasicInformationLoaded);
    }

    private setupSummerNoteHtmlEditor() {
        const descriptionTarget = $(this.descriptionTarget);
        attachSummernote(descriptionTarget, (sanitizedHtml: string) => {
            if (sanitizedHtml.length >= PointOfInterestConstants.minimumPoiDescriptionLengthToQualifyForFreeContentQuality
                && this.contentQualityTarget.value === `${ContentQuality.Insufficient}`) {
                this.contentQualityTarget.value = "";
            } 
            else if (sanitizedHtml.length < PointOfInterestConstants.minimumPoiDescriptionLengthToQualifyForFreeContentQuality 
                && this.contentQualityTarget.value === "") {
                this.contentQualityTarget.value = `${ContentQuality.Insufficient}`;
            }
        });
        attachSummernote($(this.extraInfoTarget));
    }

    private configureAuthorSearch() {
        configureTypeaheadAutocomplete(
            this.searchUsersUrlValue,
            $(this.authorTargets),
            $(this.authorUserIdTarget),
            user => `${user.userName} (${user.userEmail}, ${user.companyName})`,
            "userId",
            "$searchTerm"
        );
    }
}
